import { NoData } from "pro-features/components/NoData/src/NoData";
import styled from "styled-components";
import { translate } from "app/filters/i18nFilter";
import { InitialStateIcon, InitialStateIconWrapper } from "app/pages/industry-analysis/market-builder/tabs/common/styled";

const EmptySuggestionsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const EmptySuggestions = () => {
    return (
        <EmptySuggestionsContainer>
            <NoData
                title={""}
                subtitle={translate("website.research.market.builder.suggestions.empty")}
                SvgImage={() => (
                    <InitialStateIconWrapper>
                        <InitialStateIcon iconName={"company-empty-suggestions"} />
                    </InitialStateIconWrapper>
                )}
            />
        </EmptySuggestionsContainer>
    );
};
